import { connectedStore } from '../../store';
import selectors from '../selectors';

const getSiteId = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getSiteId(state);
};

export default getSiteId;
